<template>
    <div class="flex flex-col justify-center gap-1">
        <h2 class="text-titles text-center text-lg font-black uppercase">
            <i18n-t v-if="currentPlayerState?.is_killer" keypath="killer.player_is_killer" tag="span">
                <template #name>
                    <span class="text-white">{{ currentPlayer?.tag_name }}</span>
                </template>
            </i18n-t>
            <i18n-t v-else keypath="killer.player_turn" tag="span">
                <template #name>
                    <span class="text-white">{{ currentPlayer?.tag_name }}</span>
                </template>
            </i18n-t>
        </h2>
        <svg
            width="232"
            height="121"
            viewBox="0 0 232 121"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <g clip-path="url(#clip0_20380_103926)">
                <path
                    d="M230.78 0H0V121L20.7939 95.7087H127.429L141.81 110.145H177.558L188.018 120.994H217.584L232 107.167"
                    fill="#3F3F3F"
                />
                <path
                    d="M219.879 9.8393V103.284C219.879 103.766 219.59 104.155 219.232 104.155H145.042C144.874 104.155 144.707 104.068 144.591 103.905L128.614 88.7316H16.6242C16.2657 88.7316 15.9766 88.3427 15.9766 87.8609V10.652C15.9766 10.1702 16.2657 9.78125 16.6242 9.78125H86.1762"
                    fill="#050505"
                />
                <path d="M122.879 30.3184H122.035V67.521H122.879V30.3184Z" fill="white" />
                <path
                    d="M82.4277 76H72.0703V67.4796H66.9356V76H56.5782V67.4796H47.0608C45.3747 67.4796 44 66.1107 44 64.4287V35.0509C44 33.3688 45.3747 32 47.0608 32H91.9392C93.6253 32 95 33.3688 95 35.0509V64.4287C95 66.1107 93.6253 67.4796 91.9392 67.4796H82.4218V76H82.4277ZM72.6108 75.4664H81.8872V66.946H91.9451C93.3315 66.946 94.4654 65.8149 94.4654 64.4287V35.0509C94.4654 33.6646 93.3374 32.5336 91.9451 32.5336H47.0667C45.6802 32.5336 44.5464 33.6646 44.5464 35.0509V64.4287C44.5464 65.8149 45.6743 66.946 47.0667 66.946H57.1245V75.4664H66.401V66.946H72.6166V75.4664H72.6108Z"
                    fill="url(#paint0_linear_20380_103926)"
                />
                <path
                    d="M44.0059 32.7542V61.8168C44.0059 63.3373 45.2685 64.571 46.8248 64.571H56.7148V73H66.634V64.571H72.3718V73H82.2911V64.571H92.181C93.7373 64.571 95 63.3373 95 61.8168V32.7542C95 31.2337 93.7373 30 92.181 30H46.819C45.2627 30 44 31.2337 44 32.7542H44.0059ZM63.4686 49.4229H49.544V43.5817H63.4686V49.4229ZM65.8118 54.7993L69.5059 50.4672L73.1999 54.7993H65.8118ZM89.4678 49.4229H75.5432V43.5817H89.4678V49.4229Z"
                    fill="url(#paint1_linear_20380_103926)"
                />
                <path
                    d="M207.5 23.5V90.5H150.687L150.538 90.3408L140.635 79.7305L140.5 79.5859V23.5H207.5Z"
                    :fill="profileColor"
                    :stroke="getLighterColor(profileColor, 30)"
                />
                <mask
                    id="mask0_20380_103926"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="141"
                    y="24"
                    width="66"
                    height="66"
                >
                    <path
                        d="M206.5 24.5V89.5H151.121L141.5 79.1914V24.5H206.5Z"
                        fill="white"
                        stroke="white"
                    />
                </mask>
                <g mask="url(#mask0_20380_103926)">
                    <image
                        width="67"
                        height="67"
                        x="141"
                        y="24"
                        preserveAspectRatio="none"
                        v-avatar-fallback="currentPlayer.avatar"
                    />
                    <rect
                        x="141"
                        y="24"
                        width="66"
                        height="66"
                        :stroke="getLighterColor(profileColor, 30)"
                        stroke-width="1"
                        fill="none"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_20380_103926"
                    x1="44.0059"
                    y1="54"
                    x2="95.0059"
                    y2="54"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop :stop-color="getLighterColor(profileColor, 20)" />
                    <stop offset="1" :stop-color="getDarkerColor(profileColor, 30)" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_20380_103926"
                    x1="45.0924"
                    y1="31.1705"
                    x2="93.8636"
                    y2="66.0198"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop :stop-color="getLighterColor(profileColor, 20)" />
                    <stop offset="1" :stop-color="getDarkerColor(profileColor, 30)" />
                </linearGradient>
                <clipPath id="clip0_20380_103926">
                    <rect width="232" height="121" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script>
import { getDarkerColor, getLighterColor } from '@/utils/colorHelpers'

export default {
    name: 'KillerIndicator',
    props: {
        currentPlayer: {
            type: Object,
            required: true,
        },
        currentPlayerState: {
            type: Object,
            required: false,
        },
        profileColor: {
            type: String,
            required: true,
        },
    },
    methods: {
        getDarkerColor,
        getLighterColor,
    },
}
</script>
